import React, { Suspense } from 'react';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import routerConfig, { isRedirect, isLazyComponent } from './router-config';

const MapRouter = () => {
  return (
    <>
      {routerConfig.map((config) => {
        if (isRedirect(config)) {
          const { path, redirect } = config;
          return (
            <Route key={path} path={path}>
              <Redirect to={redirect} />
            </Route>
          );
        }
        if (isLazyComponent(config)) {
          const { path, component } = config;
          const LazyComponent = React.lazy(component);
          return <Route key={path} path={path} component={LazyComponent} />;
        }
        const { path, component } = config;
        return <Route key={path} path={path} component={component} />;
      })}
    </>
  );
};

const Router: React.FC = () => {
  return (
    <HashRouter>
      {/* 引入Suspense来支持懒路由：https://reactjs.org/docs/code-splitting.html  */}
      <Suspense fallback={<div />}>
        <Switch>
          <MapRouter />
        </Switch>
      </Suspense>
    </HashRouter>
  );
};

export default Router;
